export const routes = [
  { path: "/login", component: "auth/login/Login", isPublic: true },
  {
    path: "/send-email",
    component: "auth/sendEmail/SendEmail",
    isPublic: true,
  },
  {
    path: "/forgot-password",
    component: "auth/forgotPassword/ForgotPassword",
    isPublic: true,
  },
  { path: "/otp-verify", component: "auth/otp/Otp", isPublic: true },
  { path: "/", component: "dashboard/Home" },
  { path: "/profile", component: "profile/Profile" },
  { path: "/category-list", component: "category/CategoryList" },
  { path: "/bank-list", component: "bank/BankList" },
  { path: "/network-list", component: "network/NetworkList" },
  { path: "/card-list", component: "card/CardList" },
  { path: "/user-list", component: "user/UserList" },
  { path: "/edit-user/:id", component: "user/EditUser" },
  { path: "/view-user/:id", component: "user/ViewUser" },
  { path: "/add-card", component: "card/AddCard" },
  { path: "/view-card/:id", component: "card/ViewCard" },
  { path: "/edit-card/:id", component: "card/EditCard" },
  { path: "/outlet-list", component: "outlet/OutletList" },
  { path: "/add-outlet", component: "outlet/AddOutlet" },
  { path: "/view-outlet/:id", component: "outlet/ViewOutlet" },
  { path: "/edit-outlet/:id", component: "outlet/EditOutlet" },
  { path: "/Outletradius-list/", component: "outletRadius/OutletRadiusList" },
  { path: "/add-offer", component: "offer/AddOffer" },
  { path: "/view-offer/:id", component: "offer/OfferView" },
  { path: "/edit-offer/:id", component: "offer/EditOffer" },
  { path: "/offer-list", component: "offer/OfferList" },
  { path: "/notifications", component: "notifications/Notifications" },
  { path: "/term-condition", component: "term&condition/TermCondition" },
  { path: "/privacy-policy", component: "privacyPolicy/PrivacyPolicy" },
  { path: "/contact", component: "contact/Contact" },
  { path: "/view-contact/:id", component: "contact/ViewContact" },
  { path: "/feedback", component: "feedback/Feedback" },
  { path: "/view-feedback/:id", component: "feedback/ViewFeedback" },
  { path: "/engagement", component: "engagement/Engagement" },
  {
    path: "/crawl-data",
    component: "crawlData/CrawlDataList",
  },
  {
    path: "/crawl-data/outlets/:source",
    component: "crawlData/CrawlOutletList",
  },
  {
    path: "/crawl-data/offers/:source",
    component: "crawlData/CrawlOfferList",
  },
  {
    path: "/crawl-data/cards/:source",
    component: "crawlData/CrawlCardList",
  },
  {
    path: "/view-crawl-outlet/:id",
    component: "crawlData/ViewCrawlOutlet",
  },
  {
    path: "/edit-crawl-offer/:id",
    component: "crawlData/EditCrawlOffer",
  },
  {
    path: "/crawl-bank",
    component: "crawlBankData/ViewCrawlBankData",
  },
  {
    path: "/crawl-offer",
    component: "crawlOfferData/ViewCrawlOfferData",
  },
  {
    path: "/homepage-config",
    component: "homepageConfig/HomepageConfig",
  },
  {
    path: "/homepage-config/:tab",
    component: "homepageConfig/HomepageConfig",
  },
  {
    path: "/settings",
    component: "settings/Settings",
  },
  {
    path: "/n8n-crawl-config",
    component: "n8nCrawlConfig/N8NCrawlConfigList",
  },
  {
    path: "/search-reports",
    component: "searchReports/SearchReports",
  },
  {
    path: "/version-control",
    component: "versionControl/VersionControl",
  },
  {
    path: "/city",
    component: "city/City",
  },
  {
    path: "/outlet-duplicates",
    component: "outletDuplicate/OutletDuplicate",
  },
  {
    path: "/card-discovery",
    component: "cardDiscovery/CardDiscovery",
  },
];
